import { AUTO_EVENTS, DEVICE_EVENT_TAB_ENUM, AUTO_EVENT_TAB_ENUM } from '@/shared/config';

export const DEVICE_EVENT_TABS = [
  {
    key: DEVICE_EVENT_TAB_ENUM.NOTIFICATION,
    title: 'Included in report',
  },
  {
    key: DEVICE_EVENT_TAB_ENUM.PATIENT_TRIGGERED,
    title: 'Patient triggered',
  },
  {
    key: DEVICE_EVENT_TAB_ENUM.OTHER,
    title: 'Other',
  },
];

export const MAP_AUTO_EVENT_TYPE = {
  [AUTO_EVENT_TAB_ENUM.OTHER]: ['OTHERS'],
  [AUTO_EVENT_TAB_ENUM.VE]: [
    'SINGLE_VE',
    'VE_RUN',
    'VE_COUPLET',
    'VE_TRIGEMINAL',
    'VE_QUADRIGEMINY',
    'VE_BIGEMINY',
  ],
  [AUTO_EVENT_TAB_ENUM.SVE]: [
    'SINGLE_SVE',
    'SVE_RUN',
    'SVE_COUPLET',
    'SVE_TRIGEMINAL',
    'SVE_QUADRIGEMINY',
    'SVE_BIGEMINY',
  ],
  [AUTO_EVENT_TAB_ENUM.AFIB]: ['AFIB'],
  [AUTO_EVENT_TAB_ENUM.TACHY]: ['TACHY'],
  [AUTO_EVENT_TAB_ENUM.BRADY]: ['BRADY'],
  [AUTO_EVENT_TAB_ENUM.PAUSE]: ['PAUSE'],
  [AUTO_EVENT_TAB_ENUM.VT]: ['VT'],
  [AUTO_EVENT_TAB_ENUM.SVT]: ['SVT'],
  [AUTO_EVENT_TAB_ENUM.MIN_HR]: ['MIN_HR'],
  [AUTO_EVENT_TAB_ENUM.MAX_HR]: ['MAX_HR'],
  [AUTO_EVENT_TAB_ENUM.HB]: ['AVB3', 'AVB2'],
};

export const AUTO_EVENT_TABS = [
  {
    key: AUTO_EVENT_TAB_ENUM.OTHER,
    title: 'Other',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.VE,
    title: 'VE',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.SVE,
    title: 'SVE',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.AFIB,
    title: 'AFib',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.TACHY,
    title: 'Tachy',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.BRADY,
    title: 'Brady',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.PAUSE,
    title: 'Pause',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.VT,
    title: 'VT',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.SVT,
    title: 'SVT',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.MIN_HR,
    title: 'Min HR',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.MAX_HR,
    title: 'Max HR',
  },
  {
    key: AUTO_EVENT_TAB_ENUM.HB,
    title: 'HB',
  },
];

export const VALID_DEVICE_EVENT_STATUS_OPTIONS = [
  { label: 'Valid', value: true },
  { label: 'Invalid', value: false },
];

export const CHECK_KEEP_LAST_HEART_RATE_STRIPS_TYPE = [
  AUTO_EVENTS,
  AUTO_EVENT_TAB_ENUM.MAX_HR,
  AUTO_EVENT_TAB_ENUM.MIN_HR,
];
